//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapActions } from "vuex";
import marked from "marked";
import DOMPurify from "dompurify";
import { uuid } from "short-uuid";
import { copyToClipboard, getActualDateTime } from "@/assets/js/appFunc";
import AQMenu from "@/components/Generics/AQMenu/AQMenu.vue";
import AQInput from "@/components/Generics/AQInput/AQInput.vue";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import AQCheckbox from "@/components/Generics/AQCheckbox/AQCheckbox.vue";
import roboI from "@/assets/images/robo2_16px.svg";

export default {
    name: "AIPromptTask",
    components: { AQButton, AQInput, AQCheckbox, AQMenu },
    props: {
        isExternal: { type: Boolean, default: false }
    },
    data() {
        return {
            show: true,
            actionSelected: null,
            roboIcon: `img:${roboI}`,
            targetTopic: "",
            searchDocs: "",
            docChecked: [],
            isMinimized: false,
            uploadersList: [],
            noDocsSelected: false,
            docsIds: [],
            mandatoryUserPrompt: false,
            currentResponse: "",
            responseInProgress: false,
            replyInProgress: false,
            rawFormat: "",
            messages: [],
            userReply: "",
            assistantId: "",
            threadId: "",
            cancelPerformed: false,
            checkAll: false,
            showMenu: [],
            existingDocs: false
        };
    },
    computed: {
        ...mapState("components", ["data", "properties", "aiActions"]),
        filteredList() {
            const lowerCaseValue = this.searchDocs.toLowerCase();
            if (this.actionSelected?.selectedDocs.length) {
                return this.uploadersList.filter(item => this.actionSelected.selectedDocs.includes(item.__generics.code));
            }
            return this.uploadersList.filter(doc => (doc.label || "").toLowerCase().includes(lowerCaseValue));
        },
        showText() {
            return this.aiActions && this.aiActions.length > 1;
        },
        getTopicLabel() {
            let labelToReturn = "";
            if (this.actionSelected.action === "targeted") {
                labelToReturn = this.$t("userInterface.auraAssist.topicLabel");
            } else if (this.actionSelected.action === "custom") {
                labelToReturn = this.$t("userInterface.auraAssist.promptLabel");
            } else if (this.actionSelected.action === "conversation") {
                labelToReturn = this.$t("apps.question");
            }
            return labelToReturn;
        },
        getLabelRply() {
            return this.actionSelected.action === "custom" ? this.$t("userInterface.auraAssist.promptLabel") : this.$t("apps.question");
        },
        showDocsList() {
            return this.actionSelected.allowUserSelDocs || (!this.actionSelected.allowUserSelDocs && this.actionSelected.selectedDocs.length);
        },
        getPlaceholderText() {
            return this.actionSelected.selectedDocs.length ? this.$t("userInterface.auraAssist.docsAlreadySelectedPlaceholder")
                : this.$t("userInterface.auraAssist.docsForSelection");
        },
        showTargetTopic() {
            return (this.actionSelected.action === "targeted" || this.actionSelected.userPrompt) && !this.currentResponse && !this.responseInProgress;
        },
        menuOptions() {
            return [
                {
                    label: this.$t("userInterface.auraAssist.exportPDFAnswers"),
                    value: "ALL_ANSWERS"
                },
                {
                    label: `${this.$t(`userInterface.auraAssist.exportPDFAll.${this.actionSelected.action}`)}`,
                    value: "ALL"
                }
            ];
        }
    },
    created() {
        Object.keys(this.properties).forEach(key => {
            if (this.properties[key].__component === "ctrl-upload") {
                this.uploadersList.push(this.properties[key]);
            }
        });
    },
    methods: {
        ...mapActions("components", ["docAssistantAI", "exportAIConv"]),
        copyToClipboard,
        getActualDateTime,
        openAction(itm) {
            this.mandatoryUserPrompt = false;
            this.actionSelected = itm;
            const allowUserSelectionMismatch = (this.filteredList.length && !this.actionSelected.allowUserSelDocs)
                || (!this.filteredList.length && this.actionSelected.allowUserSelDocs)
                || (!this.filteredList.length && !this.actionSelected.allowUserSelDocs);

            const noDocsOrUserInput = (!this.actionSelected.selectedDocs.length && !this.actionSelected.userPrompt
                && this.actionSelected.additionalDocs.length)
                || (!this.actionSelected.selectedDocs.length && !this.actionSelected.userPrompt && !this.actionSelected.additionalDocs.length
                && !this.actionSelected.allowUserSelDocs);
            if (allowUserSelectionMismatch && noDocsOrUserInput && this.actionSelected.action !== "targeted") {
                this.askAi();
            }
        },
        applyFontFamily(htmlString) {
            const tags = ["p", "div", "li", "span", "h1", "h2", "h3", "h4", "h5", "h6", "ol", "ul"];
            tags.forEach(tag => {
                const regex = new RegExp(`<${tag}(.*?)>`, "gi");
                htmlString = htmlString.replace(regex, `<${tag} style="font-family: Roboto"$1>`);
            });
            return htmlString;
        },
        exportPDF(msg) {
            const aiRsp = marked(msg);
            this.exportAIConv({
                conversation: this.applyFontFamily(aiRsp),
                name: this.actionSelected.name,
                dateTime: this.getActualDateTime()
            });
        },
        menuClick(evt) {
            let concatMsg = "";
            if (evt[0].value === "ALL_ANSWERS") {
                concatMsg = this.formatAIConversation();
            } else {
                concatMsg = this.formatFullConversation();
            }
            this.exportAIConv({
                conversation: this.applyFontFamily(concatMsg),
                name: this.actionSelected.name,
                dateTime: this.getActualDateTime()
            });
            this.showMenu = [];
        },
        formatAIConversation() {
            return this.messages
                .filter(el => el.sender === "ai")
                .map(elem => marked(elem.msg))
                .join("<br>");
        },
        formatFullConversation() {
            return this.messages
                .map(elem => {
                    if (elem.sender === "user") {
                        return `<div style="font-style:italic; color: #505050">${marked(elem.msg)}</div><br>`;
                    }
                    return `${marked(elem.msg)}<br>`;
                })
                .join("");
        },
        selectAllDocs(val) {
            this.docChecked = val ? this.filteredList.map(el => el.__generics.code) : [];
        },
        adjustCheckAll() {
            this.checkAll = this.docChecked.length === this.filteredList.length;
            this.noDocsSelected = false;
        },
        searchForDocs(searchValue) {
            this.searchDocs = searchValue;
        },
        traverse(data, elementsToAsk) {
            if (typeof data === "object" && data !== null) {
                Object.keys(data).forEach(key => {
                    if (elementsToAsk.includes(key)) {
                        const { text, value } = data[key];
                        if (text && value) {
                            const extractedUid = value.replace(text, "").replace(/-$/, "");
                            this.docsIds.push(extractedUid);
                        }
                    } else if (Array.isArray(data[key])) {
                        data[key].forEach(item => this.traverse(item, elementsToAsk));
                    } else if (typeof data[key] === "object" && data[key] !== null) {
                        this.traverse(data[key], elementsToAsk);
                    }
                });
            }
        },
        resetData() {
            this.actionSelected = null;
            this.targetTopic = "";
            this.docChecked = [];
            this.noDocsSelected = false;
            this.assistantId = "";
            this.threadId = "";
            this.checkAll = false;
            this.searchDocs = "";
            this.cancelAsking();
        },
        cancelAsking() {
            this.cancelPerformed = true;
            this.currentResponse = "";
            this.responseInProgress = false;
            this.rawFormat = "";
            this.messages = [];
        },
        getDocsCheckedList(docs) {
            return docs.reduce((list, el) => {
                Object.keys(this.properties).forEach(key => {
                    if (this.properties[key].__generics.code === el) {
                        list.push(key);
                    }
                });
                return list;
            }, []);
        },
        askReplyAi() {
            if (this.userReply) {
                this.messages.push({
                    id: uuid(),
                    sender: "user",
                    msg: this.userReply
                });
                this.$nextTick(() => {
                    const container = this.$refs.scrollContainer;
                    container.scrollTop = container.scrollHeight;
                });
                const payload = {
                    userPrompt: this.userReply,
                    assistantId: this.assistantId,
                    threadId: this.threadId,
                    localId: this.actionSelected.id
                };
                this.replyInProgress = true;
                this.userReply = "";
                this.docAssistantAI(payload).then((data) => {
                    if (this.replyInProgress && data.data.code === 200 && data.data.localId === this.actionSelected.id) {
                        const aiRsp = marked(data.data.message);
                        const sanitizedAiRsp = DOMPurify.sanitize(aiRsp);
                        this.messages.push({
                            id: uuid(),
                            sender: "ai",
                            msg: sanitizedAiRsp,
                            rawFormat: data.data.message
                        });
                        this.$nextTick(() => {
                            const container = this.$refs.scrollContainer;
                            container.scrollTop = container.scrollHeight;
                        });
                    } else if (data.data.code !== 200) {
                        this.showErrorToast("admin.labs.apiAuthentificationError");
                    }
                    this.replyInProgress = false;
                }).catch(() => {
                    this.replyInProgress = false;
                    this.showErrorToast("admin.labs.apiAuthentificationError");
                });
            }
        },
        showErrorToast(messageKey) {
            this.$toast.showNotify({
                type: "error",
                message: this.$t(messageKey),
                timeout: 1000
            });
        },
        askAi() {
            this.existingDocs = false;
            this.cancelPerformed = false;
            const docsToCheck = this.actionSelected.selectedDocs.length ? this.actionSelected.selectedDocs : this.docChecked;
            this.noDocsSelected = !docsToCheck.length && !this.actionSelected.additionalDocs.length && this.actionSelected.allowUserSelDocs;
            const elementsToAsk = this.getDocsCheckedList(docsToCheck);
            if ((this.actionSelected.action === "targeted" && !this.targetTopic)
            || (this.actionSelected.action === "custom" && !this.actionSelected.instructions && !this.targetTopic)) {
                this.mandatoryUserPrompt = true;
            }
            if (this.noDocsSelected || this.mandatoryUserPrompt) {
                return;
            }
            this.docsIds = [];
            this.traverse(this.data, elementsToAsk);
            let filteredAdditionalDocs = [];
            if (this.actionSelected.additionalDocs) {
                filteredAdditionalDocs = this.actionSelected.additionalDocs.map(item => item.docId);
            }
            this.existingDocs = this.docsIds.length || filteredAdditionalDocs.length;
            if (!this.docsIds.length && !filteredAdditionalDocs.length && this.actionSelected.allowUserSelDocs) {
                this.showErrorToast("userInterface.auraAssist.noUploadedDocs");
                return;
            }
            if (this.targetTopic) {
                this.messages.push({
                    id: uuid(),
                    sender: "user",
                    msg: `<strong>${this.getTopicLabel}:</strong><br>${this.targetTopic}`
                });
            }
            const payload = {
                docsList: this.docsIds,
                additionalDocs: filteredAdditionalDocs,
                instructions: this.actionSelected.instructions,
                userPrompt: this.targetTopic,
                localId: this.actionSelected.id
            };
            this.responseInProgress = true;
            this.docAssistantAI(payload).then((data) => {
                if (this.responseInProgress && data.data.code === 200 && data.data.localId === this.actionSelected.id) {
                    this.assistantId = data.data.assistantId;
                    this.threadId = data.data.threadId;
                    const aiRsp = marked(data.data.message);
                    this.currentResponse = DOMPurify.sanitize(aiRsp);
                    this.messages.push({
                        id: uuid(),
                        sender: "ai",
                        msg: this.currentResponse,
                        rawFormat: data.data.message
                    });
                    this.responseInProgress = false;
                } else if (!this.cancelPerformed && data.data.code !== 200) {
                    this.responseInProgress = false;
                    this.showErrorToast("admin.labs.apiAuthentificationError");
                }
            }).catch(() => {
                this.responseInProgress = false;
                if (!this.cancelPerformed) {
                    this.messages = [];
                    this.showErrorToast("admin.labs.apiAuthentificationError");
                }
            });
        }
    }
};
